module.exports = __webpack_public_path__ + "img/empty_teaching_staff.30eb007c.svg";